// Generates URL-friendly slugs (e.g. "Jennifer Lopez" -> "jennifer-lopez")
export const generateSlug = (name) => {
  return name.toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
};

export const ARTISTS = [
  {
    "name": "Kool & the Gang",
    "genre": "Funk / R&B",
    "category": "Funk",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/16/d1/9d/16d19d4c-fcb5-b67b-7a43-21ba432d9614/00602547217189.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "The Pointer Sisters",
    "genre": "Pop / R&B",
    "category": "R&B",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Features114/v4/64/13/db/6413db84-4325-81e8-df43-ac7567389520/dj.zvelubll.jpg/600x600bb.jpg"
  },
  {
    "name": "Sister Sledge",
    "genre": "Disco / Funk",
    "category": "Funk",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/1e/92/af/1e92af63-0cff-5105-bd66-c6dbd32a1e69/603497898855.jpg/600x600bb.jpg"
  },
  {
    "name": "Village People",
    "genre": "Disco / Pop",
    "category": "Disco",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/ee/35/c0/ee35c038-1bc2-d04f-3dd9-6fc20a2ada7e/00602537831074.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "The Jacksons",
    "genre": "Pop / R&B",
    "category": "Pop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/3d/9d/38/3d9d3811-71f0-3a0e-1ada-3004e56ff852/827969428726.jpg/600x600bb.jpg"
  },
  {
    "name": "Flo Rida",
    "genre": "Hip-Hop / Pop",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/14/42/a0/1442a084-36ea-09a0-ff87-d5aea0cc19f8/mzi.ktgesuhn.jpg/600x600bb.jpg"
  },
  {
    "name": "Nelly",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/27/93/26/279326b5-f393-7236-d0d4-b47ff2c032ae/10UMGIM21037.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Morris Day & the Time",
    "genre": "Funk / R&B",
    "category": "Funk",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/d2/46/bd/d246bd3a-3c04-40a8-8195-8fab55a75970/mzi.yxtdtydi.jpg/600x600bb.jpg"
  },
  {
    "name": "DJ Jazzy Jeff",
    "genre": "Hip-Hop / DJ",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/83/86/2b/83862bab-beb9-5736-509e-74eb6f261e83/dj.qtjkodwa.jpg/600x600bb.jpg"
  },
  {
    "name": "Ginuwine",
    "genre": "R&B",
    "category": "R&B",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music/44/31/43/mzi.vitmrbeq.jpg/600x600bb.jpg"
  },
  {
    "name": "Tag Team",
    "genre": "Hip-Hop",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/bf/88/33/bf88335b-e75a-66e3-009d-744010bbe1ac/5055373531441.png/600x600bb.jpg"
  },
  {
    "name": "Digital Underground",
    "genre": "Hip-Hop",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/d3/92/29/d39229e0-9f86-4806-d310-4f290f415a63/081227883461.png/600x600bb.jpg"
  },
  {
    "name": "C&C Music Factory",
    "genre": "Dance / Pop",
    "category": "Pop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/2c/b0/8f/2cb08f9a-5d78-1742-125f-99db30768100/mzi.qzhckwut.jpg/600x600bb.jpg"
  },
  {
    "name": "Tone Loc",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/c7/8b/1e/c78b1eae-509c-31c3-8c37-25439ad62c46/14CMGIM01104.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "The Sugarhill Gang",
    "genre": "Hip-Hop",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/08/59/3f/08593fb1-9fa6-3f9c-5753-f5eb6620b644/dj.jnqewlpv.jpg/600x600bb.jpg"
  },
  {
    "name": "Dru Hill",
    "genre": "R&B",
    "category": "R&B",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/b4/69/c6/b469c68e-034c-f537-0867-1b7e335e80fa/06UMGIM07216.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Quad City DJs",
    "genre": "Hip-Hop / Dance",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/b4/e1/49/b4e1495d-50a1-d151-e9db-5c2e1ea18610/mzi.ejtgilth.jpg/600x600bb.jpg"
  },
  {
    "name": "Treach of Naughty by Nature",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/18/0d/16/180d1658-965f-dba0-c1d6-632c3d5c3905/081227921965.png/600x600bb.jpg"
  },
  {
    "name": "Ying Yang Twins",
    "genre": "Hip-Hop / Crunk",
    "category": "Hip-Hop",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/7a/62/43/7a624349-568c-3347-b620-fd7d0b5460e4/13UABIM44303.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Jason Scheff (of Chicago)",
    "genre": "Rock / Pop",
    "category": "Rock",
    "featured": true,
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/f1/d6/59/f1d6598f-1010-1ac5-41f7-6e7ed6af2ea9/999990019652_cover.jpg/600x600bb.jpg"
  },
  {
    "name": "Rick Ross",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music/4d/6c/2a/mzi.edtzjvyo.jpg/600x600bb.jpg"
  },
  {
    "name": "Fat Joe",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/03/b6/e8/03b6e825-bfc2-6153-be04-4ad323c2435a/s05.jbzembth.jpg/600x600bb.jpg"
  },
  {
    "name": "Ja Rule",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/e8/7a/5e/e87a5ee1-cdb9-98c7-9fcb-a9254cd999b1/06UMGIM18696.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Ashanti",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/63/66/4e/63664e1e-8196-2f88-8fde-faf40c90ecf0/06UMGIM09883.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Keith Sweat",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/6d/0a/04/6d0a0471-a0b8-b143-428d-449e600b5516/s06.snrfggjm.jpg/600x600bb.jpg"
  },
  {
    "name": "Method Man & Redman",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/29/26/f8/2926f8e4-9955-f417-31be-d18869ea75a8/mzi.qlmvzdnk.jpg/600x600bb.jpg"
  },
  {
    "name": "Bone Thugs-N-Harmony",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/8a/2c/cd/8a2ccde1-7ddd-718f-1978-91668d050e17/mzi.onqbwzuz.jpg/600x600bb.jpg"
  },
  {
    "name": "Jadakiss",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/02/c6/e1/02c6e1cd-8d57-97b4-6ef1-77d2be004509/mzi.sjrqsmrq.jpg/600x600bb.jpg"
  },
  {
    "name": "Fabolous",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/7d/e0/9d/7de09dbb-87eb-9725-b5e8-316b3ee5ff42/08UMGIM27952.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Slick Rick",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/ee/85/86/ee85862c-aab7-dda5-4929-d03d3fcb4f75/06UMGIM01306.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Grandmaster Flash",
    "genre": "Hip-Hop / DJ",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music4/v4/18/92/d6/1892d608-1aed-dbba-0a8d-b090d42af6fd/603497883967.jpg/600x600bb.jpg"
  },
  {
    "name": "Big Daddy Kane",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/2e/31/dd/2e31dd56-1ad8-f0f5-07a4-3fedc9be5cd5/mzi.swtuijtn.jpg/600x600bb.jpg"
  },
  {
    "name": "Rakim",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/da/37/e7/da37e78e-5c22-700f-2f6a-2b2d6af84a2e/06UMGIM01880.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "EPMD",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/78/42/9f/78429f29-fb13-02fe-3769-8852629d182c/13ULAIM49223.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "MC Lyte",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/11/b5/1d/11b51d84-8f90-dfb7-cf15-661a24e8a843/603497880737.jpg/600x600bb.jpg"
  },
  {
    "name": "Warren G",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/03/ef/53/03ef5302-65c7-b0e1-9877-926257626ead/15UMGIM77911.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Too $hort",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/e2/79/9b/e2799bd7-5d2e-da51-2259-5cda49f94e7c/mzi.ufqbmtky.jpg/600x600bb.jpg"
  },
  {
    "name": "Twista",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/62/15/54/621554be-4a24-0be2-c9fd-c58177701bf2/dj.zrudcxub.jpg/600x600bb.jpg"
  },
  {
    "name": "Juvenile",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/f5/87/5c/f5875c96-d540-e7de-696b-4abaa1e497dc/5059449165745.png/600x600bb.jpg"
  },
  {
    "name": "Paul Wall",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/fb/8e/60/fb8e6043-4231-aa56-dea6-7aaf4b6e0dc6/00054391563866_Cover.jpg/600x600bb.jpg"
  },
  {
    "name": "Chingy",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/b7/1b/20/b71b20df-80f0-ee67-7732-cefaebcc5f17/13ULAIM49574.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Petey Pablo",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/0e/de/33/0ede33e6-b1f6-991e-2a48-8fddebb3962d/mzi.mgsfmcfa.jpg/600x600bb.jpg"
  },
  {
    "name": "David Banner",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/86/fb/75/86fb757e-4134-f2d5-b2f1-6fdc15cf0a4e/00602567017752.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Yung Joc",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/00/f0/e1/00f0e199-13d5-33c4-bc76-edf88b3876b5/886449120666.jpg/600x600bb.jpg"
  },
  {
    "name": "Baby Bash",
    "genre": "Hip-Hop / Latin",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/60/03/d4/6003d49f-73a1-2e8f-7bcd-0e3e6764a0f7/06UMGIM11312.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "MIMS",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": null
  },
  {
    "name": "Kid Capri",
    "genre": "Hip-Hop / DJ",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music118/v4/d5/0b/fa/d50bfafa-57e4-8c83-a7aa-77ac5f3c9326/00602547135643.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Goodie Mob",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/22/97/39/2297397b-2a78-8b46-79ac-c2f5db43109a/886448839583.jpg/600x600bb.jpg"
  },
  {
    "name": "Talib Kweli",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": null
  },
  {
    "name": "The Pharcyde",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": null
  },
  {
    "name": "DJ Paul of Three 6 Mafia",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/4c/44/30/4c4430dd-150b-d393-ec70-4894975f4b16/888880422095.jpg/600x600bb.jpg"
  },
  {
    "name": "Sir Mix-A-Lot",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/59/20/96/59209622-9efb-ea58-ecff-804e3a85abc9/00602537351213.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Kid 'n Play",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/ec/d8/71/ecd87149-3249-01b9-94be-ca2fde8e9050/5034644228204.jpg/600x600bb.jpg"
  },
  {
    "name": "Darryl 'DMC' McDaniels",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": null
  },
  {
    "name": "Candyman",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": null
  },
  {
    "name": "2 Live Crew",
    "genre": "Hip-Hop / Rap",
    "category": "Hip-Hop",
    "image": null
  },
  {
    "name": "Rahzel & Roots Disciples",
    "genre": "Hip-Hop",
    "category": "Hip-Hop",
    "image": null
  },
  {
    "name": "Monica",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "En Vogue",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "SWV (Sisters With Voices)",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Blackstreet",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Jagged Edge",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Montell Jordan",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Sisqo",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Omarion",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Tank",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "K-Ci & JoJo",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/5b/23/5b/5b235b02-d260-e8ac-dbac-b0ea6924aa98/06UMGIM21106.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Johnny Gill",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Eddie Levert",
    "genre": "R&B / Soul",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/75/c7/ab/75c7ab97-7f4f-865d-b736-0d53eb14945b/mzi.jcpaarbh.jpg/600x600bb.jpg"
  },
  {
    "name": "Joe",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "After 7",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Bobby V",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Jon B",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Carl Thomas",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Donell Jones",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/0c/0c/19/0c0c1958-7c28-1dac-0d53-26ef153386a5/730082606028.jpg/600x600bb.jpg"
  },
  {
    "name": "Tevin Campbell",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/9f/8c/f7/9f8cf782-ec14-6197-0d58-037fcb3cdf32/mzi.brrhxbzw.jpg/600x600bb.jpg"
  },
  {
    "name": "Next",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/60/38/13/60381345-6d9b-1697-1a2e-d303b4244518/mzi.orxwbpbl.jpg/600x600bb.jpg"
  },
  {
    "name": "Silk",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/bc/35/a3/bc35a3e4-0898-9c44-72d4-e7ff32eecc55/s02.kzunathc.jpg/600x600bb.jpg"
  },
  {
    "name": "J Holiday",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Marques Houston",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Al B Sure",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/bd/53/04/bd5304a3-88cc-14a0-28d5-d479df31b794/mzi.qjwckynn.jpg/600x600bb.jpg"
  },
  {
    "name": "Ruben Studdard",
    "genre": "R&B / Soul",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Dwele",
    "genre": "R&B / Neo-Soul",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Kenny Lattimore",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Chante Moore",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/88/00/74/880074ac-5e2e-9a28-c052-bb4f009be58a/00008811060527.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Kelly Price",
    "genre": "R&B / Gospel",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/81/5a/5e/815a5e56-2149-4855-e976-d2490bafcc99/07UMGIM13764.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Ruff Endz",
    "genre": "R&B",
    "category": "R&B",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/6c/c1/16/6cc11650-f196-6ab6-b6c8-39eebdf8668d/mzi.slkrkgev.jpg/600x600bb.jpg"
  },
  {
    "name": "Color Me Badd",
    "genre": "R&B / Pop",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Stokley (of Mint Condition)",
    "genre": "R&B / Funk",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Will Downing",
    "genre": "R&B / Jazz",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Jeffrey Osborne",
    "genre": "R&B / Soul",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Peabo Bryson",
    "genre": "R&B / Soul",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Freddie Jackson",
    "genre": "R&B / Soul",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Howard Hewett",
    "genre": "R&B",
    "category": "R&B",
    "image": null
  },
  {
    "name": "The O'Jays",
    "genre": "Soul / Funk",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Cameo",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Ohio Players",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "The Bar-Kays",
    "genre": "Funk / Soul",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Zapp Band",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "ConFunkShun",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Dazz Band",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Midnight Star",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Rose Royce",
    "genre": "Funk / Soul",
    "category": "Funk",
    "image": null
  },
  {
    "name": "The S.O.S. Band",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Original Lakeside",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "The Stylistics",
    "genre": "Soul / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Shalamar",
    "genre": "Disco / Funk",
    "category": "Disco",
    "image": null
  },
  {
    "name": "The Whispers",
    "genre": "Soul / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "The Dramatics",
    "genre": "Soul / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "L.T.D.",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Al McKay's Earth Wind & Fire Experience",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "The Family Stone",
    "genre": "Funk / Rock",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Stone City Band",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Thomas McClary's Commodores Experience",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "The Brothers Johnson",
    "genre": "Funk / R&B",
    "category": "Funk",
    "image": null
  },
  {
    "name": "Tavares",
    "genre": "Disco / R&B",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Evelyn \"Champagne\" King",
    "genre": "Disco / R&B",
    "category": "Disco",
    "image": null
  },
  {
    "name": "The Trammps feat. Earl Young",
    "genre": "Disco / Soul",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Thelma Houston",
    "genre": "Disco / R&B",
    "category": "Disco",
    "image": null
  },
  {
    "name": "A Taste of Honey",
    "genre": "Disco / R&B",
    "category": "Disco",
    "image": null
  },
  {
    "name": "La Bouche",
    "genre": "Dance / Eurodance",
    "category": "Disco",
    "image": null
  },
  {
    "name": "First Ladies of Disco",
    "genre": "Disco",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Martha Wash",
    "genre": "Dance / Pop",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Lisa Lisa",
    "genre": "Dance / Pop",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Club Nouveau",
    "genre": "R&B / Dance",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Boogie Wonder Band",
    "genre": "Disco / Funk",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Ready for the World",
    "genre": "R&B / Funk",
    "category": "Disco",
    "image": null
  },
  {
    "name": "Dionne Warwick",
    "genre": "Pop / Soul",
    "category": "Pop",
    "image": null
  },
  {
    "name": "The Four Tops",
    "genre": "Motown / Soul",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Martha Reeves & the Vandellas",
    "genre": "Motown / Soul",
    "category": "Pop",
    "image": null
  },
  {
    "name": "The Drifters feat. Rick Sheppard",
    "genre": "Doo-Wop / R&B",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Baha Men",
    "genre": "Pop / Dance",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Tiffany",
    "genre": "Pop",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Blessid Union of Souls",
    "genre": "Pop / Rock",
    "category": "Rock",
    "image": null
  },
  {
    "name": "Melba Moore",
    "genre": "R&B / Pop",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Regina Belle",
    "genre": "R&B / Pop",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Patti Austin",
    "genre": "Jazz / R&B",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Maxine Nightingale",
    "genre": "Pop / Soul",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Toni Tony Tone",
    "genre": "R&B / Funk",
    "category": "R&B",
    "image": null
  },
  {
    "name": "E'Casanova",
    "genre": "Pop / R&B",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Temptations Revue feat. Nate Evans",
    "genre": "Motown / Soul",
    "category": "Pop",
    "image": null
  },
  {
    "name": "George Michael Reborn",
    "genre": "Pop / Tribute",
    "category": "Pop",
    "image": null
  },
  {
    "name": "Luther Re-Lives",
    "genre": "R&B / Tribute",
    "category": "R&B",
    "image": null
  },
  {
    "name": "Broadway's Rock of Ages Band",
    "genre": "Rock / Musical",
    "category": "Rock",
    "image": null
  },
  {
    "name": "The Vindys",
    "genre": "Rock / Indie",
    "category": "Rock",
    "image": null
  },
  {
    "name": "Rockcellos (Emil & Dariel)",
    "genre": "Rock / Classical",
    "category": "Rock",
    "image": null
  },
  {
    "name": "End of Code",
    "genre": "Rock",
    "category": "Rock",
    "image": null
  },
  {
    "name": "Najee",
    "genre": "Jazz / R&B",
    "category": "Jazz",
    "image": null
  },
  {
    "name": "Pete Escovedo",
    "genre": "Latin Jazz",
    "category": "Jazz",
    "image": null
  },
  {
    "name": "Eumir Deodato",
    "genre": "Jazz / Brazilian",
    "category": "Jazz",
    "image": null
  },
  {
    "name": "Miri Ben-Ari",
    "genre": "Hip-Hop Violin / Jazz",
    "category": "Jazz",
    "image": null
  },
  {
    "name": "Tito Puente Jr.",
    "genre": "Latin / Salsa",
    "category": "Jazz",
    "image": null
  },
  {
    "name": "Patrizio Buanne",
    "genre": "Italian Pop",
    "category": "Jazz",
    "image": null
  },
  {
    "name": "Jakarta Band",
    "genre": "World / Dance",
    "category": "Jazz",
    "image": null
  },
  {
    "name": "Yolanda Adams",
    "genre": "Gospel / R&B",
    "category": "Gospel",
    "image": null
  },
  {
    "name": "Shirley Caesar",
    "genre": "Gospel",
    "category": "Gospel",
    "image": null
  },
  {
    "name": "Fred Hammond",
    "genre": "Gospel",
    "category": "Gospel",
    "image": null
  },
  {
    "name": "Marvin Sapp",
    "genre": "Gospel",
    "category": "Gospel",
    "image": null
  },
  {
    "name": "Sounds of Blackness",
    "genre": "Gospel / R&B",
    "category": "Gospel",
    "image": null
  },
  {
    "name": "The Hamiltones",
    "genre": "Gospel / R&B",
    "category": "Gospel",
    "image": null
  },
  {
    "name": "Jennifer Lopez",
    "genre": "Pop / Latin",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Drake",
    "genre": "Hip-Hop / Rap",
    "category": "A-List",
    "image": "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/51/61/f3/5161f3c4-2292-f035-eb68-6f95bbc9edd6/00602537542338.rgb.jpg/600x600bb.jpg"
  },
  {
    "name": "Bruno Mars",
    "genre": "Pop / Funk",
    "category": "A-List",
    "image": null
  },
  {
    "name": "The Weeknd",
    "genre": "R&B / Pop",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Post Malone",
    "genre": "Hip-Hop / Pop",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Beyoncé",
    "genre": "Pop / R&B",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Ed Sheeran",
    "genre": "Pop / Acoustic",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Adele",
    "genre": "Pop / Soul",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Rihanna",
    "genre": "Pop / R&B",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Eminem",
    "genre": "Hip-Hop / Rap",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Maroon 5",
    "genre": "Pop / Rock",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Coldplay",
    "genre": "Alternative / Rock",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Justin Timberlake",
    "genre": "Pop / R&B",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Usher",
    "genre": "R&B / Pop",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Chris Brown",
    "genre": "R&B / Pop",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Lil Wayne",
    "genre": "Hip-Hop / Rap",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Snoop Dogg",
    "genre": "Hip-Hop / Rap",
    "category": "A-List",
    "image": null
  },
  {
    "name": "50 Cent",
    "genre": "Hip-Hop / Rap",
    "category": "A-List",
    "image": null
  },
  {
    "name": "Pitbull",
    "genre": "Pop / Latin",
    "category": "A-List",
    "image": null
  },
  {
    "name": "John Legend",
    "genre": "R&B / Soul",
    "category": "A-List",
    "image": null
  }
].map(artist => ({ ...artist, slug: generateSlug(artist.name) }));

export const CATEGORIES = ['All', 'A-List', 'Hip-Hop', 'R&B', 'Funk', 'Disco', 'Pop', 'Rock', 'Jazz', 'Gospel'];
